import { useState } from 'react';
import { useGallery } from '../context/GalleryContext';
import { Photo } from '../types';
import { GalleryGrid, ImageViewer, Search } from '../components';

const Gallery = () => {
  const { state, actions } = useGallery();
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const handlePhotoClick = (photo: Photo) => {
    actions.selectPhoto(photo);
    setIsViewerOpen(true);
  };

  const handleCloseViewer = () => {
    setIsViewerOpen(false);
    actions.selectPhoto(null);
  };

  const handleNavigatePhoto = (photo: Photo) => {
    actions.selectPhoto(photo);
  };

  const handlePageChange = (page: number) => {
    actions.loadPhotos(page, state.searchFilters);
  };

  return (
    <div>
      <h2>Photo Gallery</h2>
      
      {/* Search Component */}
      <Search
        onSearch={actions.searchPhotos}
        onClear={actions.clearSearch}
        loading={state.loading}
        initialFilters={state.searchFilters}
      />

      {/* Gallery Grid Component */}
      <GalleryGrid
        photos={state.photos}
        loading={state.loading}
        error={state.error}
        onPhotoClick={handlePhotoClick}
        onLoadMore={actions.loadMorePhotos}
        hasMore={state.currentPage < state.totalPages}
        loadingMore={state.loadingMore}
        onRetry={actions.retryLoadPhotos}
      />

      {/* Traditional Pagination (fallback for users who prefer it) */}
      {state.totalPages > 1 && (
        <div style={{ textAlign: 'center', marginTop: '2rem', padding: '1rem' }}>
          <button
            onClick={() => handlePageChange(state.currentPage - 1)}
            disabled={state.currentPage === 1 || state.loading}
            style={{
              padding: '0.5rem 1rem',
              marginRight: '0.5rem',
              backgroundColor: state.currentPage === 1 ? '#f8f9fa' : '#007bff',
              color: state.currentPage === 1 ? '#6c757d' : 'white',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              cursor: state.currentPage === 1 ? 'not-allowed' : 'pointer'
            }}
          >
            Previous
          </button>
          <span style={{ margin: '0 1rem', color: '#6c757d' }}>
            Page {state.currentPage} of {state.totalPages}
          </span>
          <button
            onClick={() => handlePageChange(state.currentPage + 1)}
            disabled={state.currentPage === state.totalPages || state.loading}
            style={{
              padding: '0.5rem 1rem',
              marginLeft: '0.5rem',
              backgroundColor: state.currentPage === state.totalPages ? '#f8f9fa' : '#007bff',
              color: state.currentPage === state.totalPages ? '#6c757d' : 'white',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              cursor: state.currentPage === state.totalPages ? 'not-allowed' : 'pointer'
            }}
          >
            Next
          </button>
        </div>
      )}

      {/* Image Viewer Modal */}
      <ImageViewer
        photo={state.selectedPhoto}
        photos={state.photos}
        isOpen={isViewerOpen}
        onClose={handleCloseViewer}
        onNavigate={handleNavigatePhoto}
      />
    </div>
  );
};

export default Gallery;